import clsx from "clsx";
import { FC } from "react";

import { onActivateKeyDown } from "@ryde/shared";

import { IRideBottomSiteDisplayItem } from "../ride-tabs-bottom-sites.models";

interface IRideTabsBottomSiteItemContentProps {
  item: IRideBottomSiteDisplayItem;
  onSiteClick: () => void;
}

export const RideTabsBottomSiteItemContent: FC<
  IRideTabsBottomSiteItemContentProps
> = ({ item, onSiteClick }) => (
  <span
    className={clsx(
      "ride-bottom-site-item",
      `ride-bottom-site-item--${item.variant}`,
      {
        link_clickable: item.isClickable,
        pointer: item.isClickable,
      },
    )}
    role={item.isClickable ? "button" : undefined}
    tabIndex={item.isClickable ? 0 : undefined}
    onClick={item.isClickable ? onSiteClick : undefined}
    onKeyDown={item.isClickable ? onActivateKeyDown(onSiteClick) : undefined}
  >
    {item.showWarningIcon && (
      <span className="ride-bottom-site-item-warning-icon" aria-hidden>
        ⚠️
      </span>
    )}
    {item.label}
  </span>
);
